<template>
    <div class="nav_box">
        <div class="nav_sin" @click="toHome('/home')">
            <img src="../assets/images/nav/wgxt.png" alt="" />
            <div class="names">网管系统</div>
            <div class="bg"></div>
        </div>
        <div class="nav_sin" @click="toHome('/homeDd')">
            <img src="../assets/images/nav/ddxt.png" alt="" />
            <div class="names">调度系统</div>
            <div class="bg"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Nav",
    data() {
        return {};
    },
    components: {},
    computed: {},
    mounted() {},
    methods: {
        // 跳转
        toHome(val) {
            if (val == "/home") {
                this.$cookies.set("menuNum", 0);
                this.$router.push("/home");
            }
            this.$router.push(val);
        },
    },
};
</script>
<style lang='less' scoped>
.nav_box {
    width: 100%;
    height: 100%;
    background: #14293c;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .nav_sin {
        width: 24rem;
        height: 30rem;
        border-radius: 10px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        img {
            width: 359px;
            height: 359px;
            z-index: 1;
        }
        .names {
            font-family: PingFang SC;
            font-size: 1.2rem;
            font-weight: 600;
            color: #ffffff;
            z-index: 1;
            margin-top: 3rem;
        }
        .bg {
            width: 100%;
            height: 100%;
            background: #4a7092;
            filter: blur(245px);
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .nav_sin:first-child {
        margin-right: 3.3rem;
    }
    .nav_sin:hover {
        background: linear-gradient(
            180deg,
            #4a7092 0%,
            rgba(74, 112, 146, 0) 100%
        );
    }
}
</style>